// Kopf der E-Mail in der Pille (Prototyp `heads.mail`): Papierflieger, Mail-Blau; Badge je Modus.
import { PaperPlaneTilt } from '@phosphor-icons/react';
import type { FormMeta } from './form-stil';

export const MAIL_FORM_META: FormMeta = { icon: PaperPlaneTilt, farbe: 'mailblau', badge: 'plus' };
export const MAIL_ANTWORT_META: FormMeta = { icon: PaperPlaneTilt, farbe: 'mailblau', badge: 'antworten' };
